/**
 * REFACTORED: novicell_product-information.js
 * Exposes window.initProductInformation for re-initialization
 */

window.initProductInformation = function() {
  // --- 1. Menu Items Logic ---
  const menuItems = document.querySelectorAll(".product-info-menu-item");
  const allSections = document.querySelectorAll(".product-info-right-content > div");

  function activateTab(item) {
    const target = item.dataset.target;
    const display = item.dataset.display || '!tw-flex';

    allSections?.forEach(section => {
      section.classList.remove("display-none");
      if (section.classList.contains(`product-info-${target}`)) {
        section.classList.remove('display-none');
        section.classList.add(display);
      } else {
        section.classList.remove(display);
        section.classList.add('display-none');
      }
    });

    menuItems.forEach(i => {
      i.classList.remove("active");
      if (i.getAttribute('role') === 'tab') {
        i.setAttribute('aria-selected', 'false');
        i.setAttribute('tabindex', '-1');
      }
      if (i.getAttribute('role') === 'button') {
        i.setAttribute('aria-expanded', 'false');
      }
    });
    item.classList.add("active");
    if (item.getAttribute('role') === 'tab') {
      item.setAttribute('aria-selected', 'true');
      item.setAttribute('tabindex', '0');
    }
    if (item.getAttribute('role') === 'button') {
      item.setAttribute('aria-expanded', 'true');
    }
  }

  menuItems?.forEach(item => {
    item.addEventListener("click", () => {
      const target = item.dataset.target;
      const targetSection = document.querySelector(`.product-info-${target}`);
      const isActive = item.classList.contains("active");
      const isMobile = window.innerWidth < 768;

      if (isMobile && isActive) {
        item.classList.remove("active");
        if (targetSection) targetSection.classList.add("display-none");
        if (item.getAttribute('role') === 'button') {
          item.setAttribute('aria-expanded', 'false');
        }
      } else {
        activateTab(item);
      }
    });

    if (item.getAttribute('role') === 'tab') {
      item.addEventListener('keydown', (event) => {
        const tablist = item.closest('[role="tablist"]');
        if (!tablist) return;
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(item);
        let nextTab;

        switch (event.key) {
          case 'Enter':
          case ' ':
            event.preventDefault();
            activateTab(item);
            return;
          case 'ArrowRight':
            nextTab = tabs[(currentIndex + 1) % tabs.length];
            break;
          case 'ArrowLeft':
            nextTab = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
            break;
          case 'Home':
            nextTab = tabs[0];
            break;
          case 'End':
            nextTab = tabs[tabs.length - 1];
            break;
          default:
            return;
        }

        event.preventDefault();
        activateTab(nextTab);
        nextTab.focus();
      });
    }

    // Mobile accordion triggers: <p role="button"> isn't natively activated by
    // Enter or Space, so wire it up manually.
    if (item.getAttribute('role') === 'button') {
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          item.click();
        }
      });
    }
  });

  // --- 2. Slider Logic ---
  const slider = document.getElementById('scrollable');
  
  if (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('cursor-grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault();
    });
  
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('cursor-grabbing');
    });
  
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('cursor-grabbing');
    });
  
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  // --- 3. Magnifier Logic ---
  const image = document.querySelector('.product-info-dimensions .desktop-dimensions-image:not(.no-zoom)');
      
  if (image) {
      // Cleanup any existing lenses from previous initializations to prevent duplicates
      document.querySelectorAll('.magnifier-lens').forEach(el => el.remove());

      let lens = null;
      const zoomLevel = 2.5;
      const lensSize = 200;

      function createLens() {
          lens = document.createElement('div');
          lens.className = 'magnifier-lens';
          document.body.appendChild(lens);
      }

      function showLens() {
          if (!lens) createLens();
          lens.classList.add('active');
      }

      function hideLens() {
          if (lens) lens.classList.remove('active');
      }

      function updateLens(e) {
          if (!lens) return;

          const rect = image.getBoundingClientRect();
          const x = e.clientX;
          const y = e.clientY;

          lens.style.left = (x - lensSize/2) + 'px';
          lens.style.top = (y - lensSize/2) + 'px';

          const relativeX = (x - rect.left) / rect.width;
          const relativeY = (y - rect.top) / rect.height;
          const clampedX = Math.max(-0.1, Math.min(1.1, relativeX));
          const clampedY = Math.max(-0.1, Math.min(1.1, relativeY));

          const displayWidth = rect.width;
          const displayHeight = rect.height;
          const bgWidth = displayWidth * zoomLevel;
          const bgHeight = displayHeight * zoomLevel;
          
          let bgX;
          let bgY;
          if((clampedX * bgWidth - lensSize/2) < 0){
            bgX = 0;
          }else{
            bgX = clampedX * bgWidth - lensSize/2;
          }

          if((clampedY * bgHeight - lensSize/2) < 0){
            bgY = 0;
          }else{
            bgY = clampedY * bgHeight - lensSize/2;
          }
          
          lens.style.backgroundImage = `url(${image.src})`;
          lens.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
          lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
      }

      image.addEventListener('mouseenter', showLens);
      image.addEventListener('mouseleave', hideLens);
      image.addEventListener('mousemove', updateLens);
  }

  // --- 4. Dimensions Slider ---
  // swiffy-slider.js only inits sliders present on page load, so init the ones swapped in by connected products
  document.querySelectorAll('.dimensions-slider:not([data-slider-initialized])').forEach(dimensionsSlider => {
    dimensionsSlider.dataset.sliderInitialized = 'true';
    window.swiffyslider?.initSlider(dimensionsSlider);
  });
};

// Global Initialization
document.addEventListener("DOMContentLoaded", function () {
  // Already initialized by swiffy-slider.js on page load
  document.querySelectorAll('.dimensions-slider').forEach(dimensionsSlider => {
    dimensionsSlider.dataset.sliderInitialized = 'true';
  });

  window.initProductInformation();

  // --- Dimensions Modal Listener (Kept Global) ---
  // Opens the modal on the clicked drawing instead of the first one
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('.dimensions-slider modal-opener');
    if (!opener) return;
    document.querySelector(opener.dataset.modal)?.handleActiveMedia?.(opener);
  });

  // modal-opener is role="button" but not a native button, so route Enter/Space through the click path above
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const opener = event.target.closest('.dimensions-slider modal-opener');
    if (!opener) return;
    event.preventDefault();
    opener.click();
  });

  // --- Variant Listener (Kept Global) ---
  // This is attached to 'document', so it persists even when page content changes.
  // We do NOT put this inside initProductInformation to avoid duplicate listeners.
  document.addEventListener('variant:changed', (event) => {
    const factsheetLink = document.querySelector('.factsheet_link[data-base-url]');
    if (!factsheetLink || !event.detail?.variant) return;

    const baseUrl = factsheetLink.dataset.baseUrl;
    const market = factsheetLink.dataset.market;
    const units = factsheetLink.dataset.units;
    const sku = event.detail.variant.sku;

    if (market && units && sku) {
      // Encode the SKU so values with spaces/slashes (e.g. "N/A - SEE MODULES") stay a valid URL.
      factsheetLink.href = `${baseUrl}/?market=${market}&units=${units}&sku=${encodeURIComponent(sku)}`;
    }
  });
});